import { render, staticRenderFns } from "./wtSlack.component.vue?vue&type=template&id=4b4ec999&"
import script from "./wtSlack.component.vue?vue&type=script&lang=js&"
export * from "./wtSlack.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports